import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../servicios/api/api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { fuenteI } from '../../../modelos/fuentes.interface';
import { EstadoEntiI } from 'src/app/modelos/estadoEntidad.interface';
import { histActFuenteI } from 'src/app/modelos/histActFuente.interface';
import { ToastrService } from 'ngx-toastr';
import { AdminFuenteService } from 'src/app/servicios/adminfuentes/AdminFuente.service';

@Component({
  selector: 'app-activacion',
  templateUrl: './activacion.component.html',
  styleUrls: ['./activacion.component.css']
})
export class ActivacionComponent implements OnInit {

  fuenteActivacion : fuenteI;
  nuevaActivaFuente : histActFuenteI;
  estadoFuente : String;
  estaEntidad : EstadoEntiI;
  histoEntidad : histActFuenteI[];
  hoy: string;
  checkCHV: Boolean;
  checkFIVI: Boolean;
  btnguardar: Boolean;

  constructor(private activerouter: ActivatedRoute,
    private router: Router,
    private api: ApiService,
    private adminFuentesService: AdminFuenteService,
    private toastr: ToastrService) { }

  ngOnInit(): void {
    let fuenteId = this.activerouter.snapshot.paramMap.get('id');
    //console.log(fuenteId);
    this.nuevaActivaFuente = new histActFuenteI;
    this.fuenteActivacion = new fuenteI;
    this.btnguardar = true;
    this.api.getFuenteById(fuenteId).subscribe(data=>{
      this.fuenteActivacion = data;
      this.estadoFuente = this.fuenteActivacion.idEstado.id;
      //console.log(this.estadoFuente);
    },error=>{
      console.log(error);
    });
    //console.log(localStorage.getItem('usuario'));
  }

  guardarActivacion(){
    this.btnguardar = false;

    if (this.estadoFuente == "1"){

      this.estaEntidad = new EstadoEntiI;
      this.estaEntidad.id = "2",
      this.estaEntidad.nombre = 'Inactivo';
      this.estaEntidad.descripcion = 'Inactivo';

      this.nuevaActivaFuente.fuente = this.fuenteActivacion;
      this.nuevaActivaFuente.fecha = new Date().toString();
      this.nuevaActivaFuente.accion = 'Inactivar';
      this.nuevaActivaFuente.novedad = 'Inactivo';
      this.nuevaActivaFuente.usuarioMod = localStorage.getItem('usuario');



      this.fuenteActivacion.idEstado = this.estaEntidad;

      this.adminFuentesService.actualizarEstadoFuente(this.fuenteActivacion).subscribe(data=>{
        //console.log(data);
        this.api.guardarHistActiv(this.nuevaActivaFuente).subscribe(data=>{
          //console.log(data);
          this.toastr.success('Fuente inactiva.', 'OK!');
          this.router.navigate(['fuentes']);
        },error=>{
          console.log(error);
        });
      },error=>{
        console.log(error);
      });
    }
    if (this.estadoFuente == "2"){
      this.estaEntidad = new EstadoEntiI;
      this.estaEntidad.id = "1",
      this.estaEntidad.nombre = 'Activo';
      this.estaEntidad.descripcion = 'Activo';

      this.nuevaActivaFuente.fuente = this.fuenteActivacion;
      this.nuevaActivaFuente.fecha = new Date().toString();
      this.nuevaActivaFuente.accion = 'Activar';
      this.nuevaActivaFuente.novedad = 'Activo';
      this.nuevaActivaFuente.usuarioMod = localStorage.getItem('usuario');

      //console.log(this.nuevaActivaFuente);
      this.fuenteActivacion.idEstado = this.estaEntidad;

      this.adminFuentesService.actualizarEstadoFuente(this.fuenteActivacion).subscribe(data=>{
        //console.log(data);
        this.api.guardarHistActiv(this.nuevaActivaFuente).subscribe(data=>{
          //console.log(data);
          this.toastr.success('Fuente activa.', 'OK!');
          this.router.navigate(['fuentes']);
        },error=>{
          console.log(error);
        });
      },error=>{
        console.log(error);
      });
    }

  }

  regresarFuentes(){
    this.router.navigate(['fuentes']);
  }

}
